import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

import React, { useState } from 'react';
import { DateRangePicker as ReactDatesDateRangePicker, DateRangePickerShape } from 'react-dates';
import { useIntl } from 'react-intl';

import { createStyles, Theme, withStyles } from '@material-ui/core';
import { Moment } from 'moment';

import messages from './messages';

const styles = ({
  palette: { primary },
  spacing: { unit },
  custom: {
    palette: { colorLightBlue },
  },
}: Theme) =>
  createStyles({
    root: {
      '& .DateInput': {
        maxWidth: 162,
      },
      '& .DateInput_input': {
        color: primary.main,
        cursor: 'pointer',
        fontFamily: '"freight-sans-pro", sans- serif',
        fontSize: 16,
        fontWeight: 500,
        padding: `${unit}px ${unit / 2}px`,
        textAlign: 'center',
      },
      '& .DateRangePickerInput__withBorder': {
        borderColor: colorLightBlue,
      },
      // Underline on input
      '& .DateInput_input__focused': {
        borderBottom: `3px solid ${primary.main}`,
      },
      // Help button for keyboard shortcuts
      '& .DayPickerKeyboardShortcuts_show__bottomRight::before': {
        borderRightColor: primary.main,
      },
      '& .DateRangePicker': {
        width: '100%',
      },
      '& .DateRangePickerInput': {
        width: '100%',
      },
    },
  });

export type DateRangePickerValues = { startDate: Moment; endDate: Moment };

export interface DateRangePickerProps extends Partial<DateRangePickerShape> {
  classes: any;
  onDatesChange: DateRangePickerShape['onDatesChange'];
  startDate: DateRangePickerShape['startDate'];
  endDate: DateRangePickerShape['endDate'];
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({ classes, ...rest }) => {
  const { formatMessage } = useIntl();
  const [focusedInput, setFocusedInput] = useState<'startDate' | 'endDate' | null>(null);

  return (
    <div className={classes.root}>
      <ReactDatesDateRangePicker
        startDateId="start-date-form-id"
        endDateId="end-date-form-id"
        startDatePlaceholderText={formatMessage(messages.startDate)}
        endDatePlaceholderText={formatMessage(messages.endDate)}
        displayFormat="ll"
        focusedInput={focusedInput}
        onFocusChange={(value) => setFocusedInput(value)}
        {...rest}
      />
    </div>
  );
};

export default withStyles(styles, { name: 'LumaDateRangePicker' })(DateRangePicker);
